import { APP_USER, FUNCTIONALITY } from 'src/app/shared/common/constants';
import { IUserData } from 'src/app/shared/interfaces/user.interface';
import { removeDotsFromText } from '../../core/utils/functions';
import { ISubscriptionRequest } from '../models/subscription-api.model';
import { ISubscriptionDraft } from '../models/subscription.model';

export const NO_EXECUTIVE_RUT = '1-9';

const splitRut = (fullRut: string): { rut: string; checkDigit: string } => {
  const rut = String(fullRut).replace(/[^0-9kK]/g, '');

  return { rut: rut.slice(0, -1), checkDigit: rut.slice(-1) };
};

export const toSubscriptionRequest = (
  draft: ISubscriptionDraft,
  user: IUserData,
  executiveRut: string
): ISubscriptionRequest => ({
  user: APP_USER,
  name: user.name,
  email: user.email,
  fundTypeDestination: draft.regimeFund.fund,
  taxRegimeCode: draft.regimeFund.regime,
  functionality: FUNCTIONALITY,
  discountType: draft.amount.currency === 'pesos' ? 'P' : 'U',
  discountValue: +removeDotsFromText(draft.amount.amount),
  employer: {
    ...splitRut(draft.employer.fullRut),
    name: draft.employer.name,
    email: draft.employer.email,
    address: draft.employer.address,
  },
  executive: splitRut(executiveRut || NO_EXECUTIVE_RUT),
});
